import { render, staticRenderFns } from "./status-sub-tatus-type.vue?vue&type=template&id=e91d5a38&"
import script from "./status-sub-tatus-type.vue?vue&type=script&lang=js&"
export * from "./status-sub-tatus-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports